import { lazy } from 'react';

// project-imports
import AuthLayout from '@/layout/Auth';
import Loadable from '@/components/base-component/Loadable';

// render - login
const AuthLogin = Loadable(lazy(() => import('@/pages/examples/auth/auth1/login')));
const AuthRegister = Loadable(lazy(() => import('@/pages/examples/auth/auth1/register')));
const AuthForgotPassword = Loadable(lazy(() => import('@/pages/examples/auth/auth1/forgot-password')));
const AuthCheckMail = Loadable(lazy(() => import('@/pages/examples/auth/auth1/check-mail')));
const AuthResetPassword = Loadable(lazy(() => import('@/pages/examples/auth/auth1/reset-password')));
const AuthCodeVerification = Loadable(lazy(() => import('@/pages/examples/auth/auth1/code-verification')));

// ==============================|| AUTH ROUTES ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        {
          path: 'login', // ไม่ต้องมี "/"
          element: <AuthLogin />
        },
        {
          path: 'register', // ไม่ต้องมี "/"
          element: <AuthRegister />
        },
        {
          path: 'forgot-password', // ไม่ต้องมี "/"
          element: <AuthForgotPassword />
        },
        // {
        //   path: 'check-mail',// ไม่ต้องมี "/"
        //   element: <AuthCheckMail />
        // },
        {
          path: 'reset-password/:id', // ไม่ต้องมี "/"
          element: <AuthResetPassword />
        }
        // {
        //   path: 'code-verification',// ไม่ต้องมี "/"
        //   element: <AuthCodeVerification />
        // }
      ]
    }
  ]
};

export default LoginRoutes;
